import React, { Component } from 'react';
import {services} from "../../services/roles.service";
import DataGrid, { Column, Editing, Paging, RequiredRule, PatternRule, StringLengthRule, Lookup } from 'devextreme-react/data-grid';
import notify from 'devextreme/ui/notify';

export class Roles extends Component{
    constructor (props){
        super(props);
        this.state={
            rows : [], 
            roleType : [{
                'id': 1,
                'name': 'Admin'
            }, {
                'id': 2,
                'name': 'Parent'
            }, {
                'id': 3,
                'name': 'Therapist'
            }, {
                'id': 4,
                'name': 'Caregiver'
            }]
        };
        this.onRowInserting = this.insert.bind(this);
        this.onRowUpdating = this.update.bind(this);
        this.onRowRemoving = this.remove.bind(this);
        //this.refreshData.bind(this);
        this.refreshData();
    };      
    
    refreshData() {
        services.getRoles().then(
            data=>{
            this.setState({ rows: data});
            },
            error=>{
                notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
            }
        );
    }

    insert(event){
        let { rows } = this.state;
        var isDuplicate = false;
        rows.forEach(row => {
            if(row.name===event.data.name){
                isDuplicate = true;
            }
        });
        if(isDuplicate){
            notify({position:'top right', message:"Failed: Role name '"+event.data.name+"' is already taken.", type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
            this.refreshData();
        }
        else{
            services.register(event.data).then(
                response=>{
                    if(response){
                        notify({position:'top right', message:'Added successfully',type:'success',maxWidth:200});
                        this.refreshData();
                    }
                }, 
                error=>{
                    notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                    this.refreshData();
                }
            );
        }
    }

    update(event){
        let { rows } = this.state;
        var newData=event.newData;
        rows = rows.map(row => (row.id===event.key ? { ...row, ...newData } : row));
        var changedRow;
        rows.forEach(row => {
            if(event.key===row.id)
            changedRow= row;
        });
        if(changedRow){
            services.update(changedRow).then(
                response=>{
                    notify({position:'top right', message:'Updated successfully',type:'success',maxWidth:200});
                }, 
                error=>{
                    notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                    this.refreshData();
                }
            );
        }
    }

    remove(event){
        services.delete(event.key).then(
            response=>{
                if(response){
                    notify({position:'top right', message:'Deleted successfully',type:'success',maxWidth:200});
                }
            }, 
            error=>{
                notify({position:'top right', message:"Failed: "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                this.refreshData();
            }
        );
    }

    render(){
        return(
            <div>
                <h4>Roles Management</h4>
                <React.Fragment>
                <DataGrid
                    id={'gridContainer'}
                    dataSource={this.state.rows}
                    keyExpr={'id'}
                    allowColumnReordering={true}
                    showBorders={true}
                    showRowLines= {true}
                    onRowInserting={this.onRowInserting}
                    onRowUpdating={this.onRowUpdating}
                    onRowRemoving={this.onRowRemoving}
                    >
                    <Paging enabled={true} />
                    <Editing
                        mode={'row'}
                        allowUpdating={true}
                        allowDeleting={true}
                        allowAdding={true} />

                    {/* <Column dataField={'id'} caption={'ID'}/> */}
                    <Column dataField={'name'} caption={'Role Name'}>
                    <RequiredRule />
                    <StringLengthRule min={2} max={200} message={"Role Name must be between 2 and 200 characters"}/>
                    <PatternRule
                        message={'Role Name must be alphanumeric character'}
                        pattern={"^[a-zA-Z0-9]*$"}
                    />
                    </Column>
                    <Column dataField={'description'} caption={'Description'}/>
                    <Column dataField={'roleType'} caption={'Role Type'}>
                        <Lookup dataSource={this.state.roleType} displayExpr={'name'} valueExpr={'id'} />
                        <RequiredRule />
                    </Column>
                    <Column dataField={'usersCount'} caption={'Users'} allowEditing={false}/>
                    
                </DataGrid>
                </React.Fragment>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Roles.js